// Neue Programmversion (Deploy) → offene Fenster aktualisieren sich selbst, ohne dass jemand F5 drücken muss.
// Alle 60 s (und beim Zurückkehren ins Fenster) wird index.html geprüft; weicht der Bundle-Hash vom geladenen ab,
// wird nachgeladen, sobald niemand gerade tippt (≥ 20 s ohne Eingabe, kein offener Dialog). Bis dahin: Hinweis-Leiste.
import { useEffect, useRef, useState } from 'react';

const PRUEF_MS = 60_000;
const RUHE_MS = 20_000;

const geladenerHash = (): string | null => {
  const s = document.querySelector('script[type="module"][src*="/assets/index-"]');
  const m = /\/assets\/(index-[\w-]+\.js)/.exec(s?.getAttribute('src') ?? '');
  return m?.[1] ?? null;
};

export function AutoUpdate() {
  const [neu, setNeu] = useState(false);
  const letzteEingabe = useRef(Date.now());

  useEffect(() => {
    const aktuell = geladenerHash();
    if (!aktuell) return;                       // Dev-Server o. ä.: nichts zu tun
    const eingabe = () => { letzteEingabe.current = Date.now(); };
    for (const ev of ['keydown', 'mousedown', 'touchstart']) window.addEventListener(ev, eingabe, { passive: true });
    let gefunden = false;
    const pruefen = async () => {
      if (gefunden) return;
      try {
        const r = await fetch(`/?v=${Date.now()}`, { cache: 'no-store', credentials: 'include' });
        const m = /\/assets\/(index-[\w-]+\.js)/.exec(await r.text());
        if (m && m[1] !== aktuell) { gefunden = true; setNeu(true); }
      } catch { /* offline */ }
    };
    const t = setInterval(() => { if (document.visibilityState === 'visible') void pruefen(); }, PRUEF_MS);
    const vis = () => { if (document.visibilityState === 'visible') void pruefen(); };
    document.addEventListener('visibilitychange', vis);
    // Neu geladen wird, wenn gerade nicht getippt wird und kein Dialog offen ist
    const warte = setInterval(() => {
      if (!gefunden) return;
      const dialogOffen = !!document.querySelector('.fixed.inset-0, [role="dialog"]');
      // nicht gesendeter Text in einem Feld (außer Suche) → nicht automatisch neu laden
      const textOffen = [...document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('textarea, input[type="text"], input:not([type])')]
        .some(f => f.value.trim() !== '' && !/^\s*(🔍|Suche)/.test(f.placeholder));
      if (Date.now() - letzteEingabe.current >= RUHE_MS && !dialogOffen && !textOffen) window.location.reload();
    }, 5_000);
    return () => {
      clearInterval(t); clearInterval(warte); document.removeEventListener('visibilitychange', vis);
      for (const ev of ['keydown', 'mousedown', 'touchstart']) window.removeEventListener(ev, eingabe);
    };
  }, []);

  if (!neu) return null;
  return (
    <div data-testid="update-hinweis" className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[95] bg-slate-900 text-white text-sm rounded-lg shadow-xl px-4 py-2 flex items-center gap-3">
      <span>🔄 Neue Version verfügbar — lädt gleich automatisch neu.</span>
      <button onClick={() => window.location.reload()} className="bg-brand text-white rounded px-3 py-1 text-xs font-semibold">Jetzt aktualisieren</button>
    </div>
  );
}
